import { cn } from '@lib/utils';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  className?: string;
}

const Card = ({ children, className }: Props) => (
  <div
    className={cn('rounded-[20px] bg-[#F7F8FA] px-[26px] py-[32px]', className)}
  >
    {children}
  </div>
);
const Title = ({ children, className }: Props) => (
  <div
    className={cn(
      'text-[20px] font-semibold leading-[32px] tracking-[-0.46px] text-3b-text-primary',
      className,
    )}
  >
    {children}
  </div>
);
const Description = ({ children, className }: Props) => (
  <div
    className={cn(
      'mt-[6px] text-sm font-medium leading-[26px] tracking-[-0.18px] text-3b-text-secondary md:text-base',
      className,
    )}
  >
    {children}
  </div>
);

Card.Title = Title;
Card.Description = Description;

export default Card;
